import { EmptyValue } from "@design-system/EmptyValue/EmptyValue";
import type { DataGridEmpty } from "../columns/types";

interface EmptyCellValueProps {
    empty: DataGridEmpty;
}

/** The column's empty-value treatment: the muted dash, nothing, or its own node. */
export const EmptyCellValue = ({ empty }: Readonly<EmptyCellValueProps>) => {
    if (empty === "dash") {
        return <EmptyValue />;
    }
    return empty === "blank" ? null : empty;
};
